import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ReactDOM from 'react-dom';

const CustomLeftArrow = ({ onClick }) => {
  const portalRoot = document.getElementById('arrow-portal');

  return portalRoot
    ? ReactDOM.createPortal(
        <button
          onClick={onClick}
          style={{
            position: 'absolute',
            left: '-50px', 
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '25px',
            zIndex: 1000,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <i className="uil uil-angle-left-b"></i>
        </button>,
        portalRoot
      )
    : null;
};

const CustomRightArrow = ({ onClick }) => {
  const portalRoot = document.getElementById('arrow-portal');

  return portalRoot
    ? ReactDOM.createPortal(
        <button
          onClick={onClick}
          style={{
            position: 'absolute',
            right: '-50px', 
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '25px',
            zIndex: 1000,
            background: 'transparent',
            borderRadius: "10px",
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <i className="uil uil-angle-right-b"></i>
        </button>,
        portalRoot
      )
    : null;
};

const CustomCarousel = ({ items, setValue, onClick }) => {
  const [selectedItem, setSelectedItem] = useState(null); // State to track the selected item

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div style={{ position: 'relative', overflow: 'visible' }} id="arrow-portal">
      <Carousel
        responsive={responsive}
        customLeftArrow={<CustomLeftArrow />}
        customRightArrow={<CustomRightArrow />}
        swipeable={true}
        draggable={true}
        infinite={true}
        partialVisible={false}
        containerClass="carousel-container"
      >
        {items.map((item, index) => (
          <div
            key={index}
            className="hover-box"
            onClick={() => {
              setSelectedItem(index); // Update the selected item
              setValue(item.label);
              if (onClick) onClick(item.label); 
            }}
            style={{
              border: selectedItem === index ? '1px solid #00d1fc' : 'none', // Add blue border if selected
              padding: '10px',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'border 0.3s',
            }}
          >
            <img
              src={item.img}
              width="60%"
              style={{
                minHeight: '90px',
                maxHeight: '90px',
                objectFit: 'contain',
              }}
              alt={item.label}
            />
            <br />
            <span
              style={{
                fontSize: '1.0rem',
                fontWeight: '600',
                color: selectedItem === index ? '#00d1fc' : 'black', // Change text color to blue if selected
              }}
            >
              {item.label}
            </span>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CustomCarousel;
